import { render, staticRenderFns } from "./AllInvestmentsRevolvingPutOptionsLegend.vue?vue&type=template&id=2091a282&scoped=true&"
var script = {}
import style0 from "./AllInvestmentsRevolvingPutOptionsLegend.vue?vue&type=style&index=0&id=2091a282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2091a282",
  null
  
)

export default component.exports